<template>
  <div class="rooms-page">
    <div v-if="groups && groups.length > 0" class="row">
      <RoomItem
        v-for="(item, index) in groups"
        :key="item._id"
        :index="index"
        :roomName="item.name"
        :roomId="item._id"
        :power="getPower(item)"
        v-on:onPowerClicked="onRoomPowerClicked"
      />
    </div>
    <div v-else class="page-empty-state">
      <div class="empty-state-icon">
        <i class="fa-regular fa-house"></i>
      </div>
      <div class="empty-state-title">등록된 방이 없습니다</div>
      <div class="empty-state-description">
        설정에서 방을 추가해주세요.
      </div>
      <button class="btn btn-primary mt-3" @click="onSettingClick">설정으로 이동</button>
    </div>
    <ZoneModal
      v-if="zoneModal.visible"
      :visible="zoneModal.visible"
      :okCallback="onUpdateZoneName"
      :cancelCallback="zoneModal.hide"
      :zoneName="zone?.name"
    />

    <NoticeItemModal
      v-if="noticeItemModal.visible"
      :visible="noticeItemModal.visible"
      :cancelCallback="onNoticeCancelClick"
      :data="currentNotice"
    />
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import {
  computed,
  getCurrentInstance,
  onBeforeMount,
  onMounted,
  reactive,
  ref, watch
} from 'vue';
import moment from 'moment'
import { useRouter } from 'vue-router';
import Axios, { ZoneApi, SmarthomeApi, ScheduleApi, VirtualDeviceApi } from '@/api';
import RoomItem from './components/RoomItem.vue';
import ZoneModal from './components/ZoneModal.vue';
import useModal from '@/common/hooks/useModal';
import { ButtonConfig, PowerState, DeviceType, MQTTTempCommand, MQTTCurtainCommand, MQTTDooyaRonoCommand, getDooyaRonoCloseCtrlData } from '@/common/constants';
import { supportsLampCmdCs, findControllerInZone } from '@/common/utils/controllerDisplayName';
import { publishVirtualButtonLampsCmdC } from '@/common/utils/virtualButtonMqtt';
import { buildTimerGroupMqttPayload, weekToDaysMask } from '@/common/utils/scheduleMqtt';
import NoticeItemModal from '../notices/components/NoticeItemModal.vue';
import useMqttControl from '@/common/hooks/useMqttControl';
import useMobile from '@/common/hooks/useMobile';
import { isMobile } from 'mobile-device-detect';

const mqttControl = reactive(useMqttControl());
const router = useRouter();
const store = useStore();
const zoneModal = reactive(useModal());
const noticeItemModal = reactive(useModal());
const showNotices = ref([]);
const currentNotice = ref();
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const { getLocalStorage, setLocalStorage } = useMobile();

const notices = computed(() => store.getters['home/getNotices']);

const zones = computed(() => {
  return store.getters['home/getZones'];
});
const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});

const groups = computed(() => {
  return zone.value?.groups || [];
});

const isPublishSchedules = computed(() => {
  return store.getters['home/getIsPublishSchedules'];
});

const publishSchedules = async () => {
  // 온도조절기 스케줄 싱크 맞추기 위해서 임시로 호출. 충분한 기간 뒤에 삭제 예정.
  if (isPublishSchedules.value) {
    return;
  }

  const devices = [];
  console.log(zones.value);
  
  zones.value.forEach(zone => {
    zone.groups?.forEach(group => {
      group.devices?.forEach(device => {
        if (device.type === 2) {
          devices.push(device);
        }
      });
    });
  });
  
  for (const device of devices) {
    try {
      const result = await Axios.get(ScheduleApi.SCHEDULES, { deviceId: device._id });
      if (result.resultCode === '0000') {
        result.resultData?.forEach((schedule, index) => {
          setTimeout(() => {
            const mqttPayload = buildTimerGroupMqttPayload({
              enable: schedule.isOn ? 1 : 0,
              days: weekToDaysMask(schedule.week),
              data: schedule.data,
            });
            console.log(mqttPayload);
            mqttControl.onPublishTemp(device.controllerId, MQTTTempCommand.SyncTimerGroup + `${index + 1}`, mqttPayload);
          }, index * 100);
        });
        store.commit('home/setIsPublishSchedules', true);
      }
    } catch (error) {
      console.log(error);
    }
  }
};

const showNoticesPopup = async () => {
  const filteredNotices = notices.value.filter((notice) => {
    const todayDate = moment().format("YYYYMMDD");
    const startDate = moment(notice.startDate).format("YYYYMMDD");
    const endDate = moment(notice.endDate).format("YYYYMMDD");
    return endDate > todayDate || todayDate < startDate;
  });

  if (isMobile) {
    try {
      const promises = filteredNotices.map(notice => getLocalStorage(`notice${notice._id}`));
      const result = await Promise.all(promises);
      showNotices.value = filteredNotices.filter((notice, index) => !result[index]);
    } catch (e) {
      console.log(e);
    }
  }

  if (showNotices.value.length > 0) {
    currentNotice.value = showNotices.value[0];
  }
}

const setEditModeOff = () => {
  const editZones = zones.value.filter(zone => zone.isEditMode);
  if (editZones.length > 0) {
    console.log("세팅모드의 영역이 있습니다. 세팅모드를 종료합니다.");
  }

  editZones.forEach(async (zone) => {
    const payload = { isEditMode: false };
    const result = await Axios.patch(
      ZoneApi.UPDATE_ZONE.replace(':id', zone._id),
      payload,
    );
    store.commit('home/updateZone', {
      id: zone._id,
      data: payload,
    });

    if (result.resultCode === '0000') {
      mqttControl.onPublishZone(zone._id, payload);
    }
  })
}

onMounted(() => {
  showNoticesPopup();
  setEditModeOff();
  console.log("publishSchedules START!!!!!!!!!!!!!!!!!!!");
  publishSchedules();
  console.log("publishSchedules END.....................");
});

watch(currentNotice, () => {
  if (currentNotice.value) {
    noticeItemModal.show();
  }
});

watch(notices, () => {
  if (!currentNotice.value) {
    showNoticesPopup();
  }
})

const onNoticeCancelClick = () => {
  noticeItemModal.hide();
  setTimeout(() => {
    const index = showNotices.value.indexOf(currentNotice.value);
    currentNotice.value = showNotices.value[index + 1];
  }, 10);
}

const getPower = (group) => {
  return group.devices.some((d) => d.item?.onoff === 1);
};

const onPowerOnClick = () => {
  if (zone.value.isEditMode) {
    emitter.emit('showPopAlert', {
      description: '세팅중인 영역의 단말은 제어 할 수 없습니다.',
    });
    return;
  }

  zone.value.controllers.forEach((item) => {
    mqttControl.onPublishFirmware(item._id, {
      serial: item._id,
      cmd: 'ao',
      type: 1,
      onoff: 1,
    });
  });
};

const onPowerOffClick = () => {
  if (zone.value.isEditMode) {
    emitter.emit('showPopAlert', {
      description: '세팅중인 영역의 단말은 제어 할 수 없습니다.',
    });
    return;
  }
  zone.value.controllers.forEach((item) => {
    mqttControl.onPublishFirmware(item._id, {
      serial: item._id,
      cmd: 'ao',
      type: 1,
      onoff: 0,
    });
  });
};

const onRoomPowerClicked = (payload) => {
  console.log(payload)
  let { id, type, onoff, close, groupId } = payload;
  let devices;
  if (type) {
    devices = groups.value
      .find((g) => g._id === id)
      .devices.filter((d) => d.type === type);
  } else {
    devices = groups.value.find((g) => g._id === id).devices;
  }

  if (type == DeviceType.Lamp) {
    onPublishLightPowerChanged(devices, onoff, groupId);
  } else if (type == DeviceType.Boiler) {
    onPublishBoilerPowerChanged(devices, onoff, groupId);
  } else if (type == DeviceType.Curtain) {
    onPublishCurtainPowerChanged(devices, close, groupId);
  } else if (type == DeviceType.Dooya) {
    onPublishDooyaPowerChanged(devices, close, groupId);
  } else if (type == DeviceType.Rono) {
    onPublishRonoPowerChanged(devices, close, groupId);
  }
};

const onPublishLightPowerChanged = async (devices, onoff, groupId) => {
  emitter.emit('showLoading');

  // for (const device of devices) {
  //   if (device.isVirtual && onoff == 0) {
  //     const params = { onoff: onoff, disableRollback: true };
  //     await requestVirtualDevicePower(params, device._id, groupId);
  //   } else {
  //     console.log(device);
  //     const data = {
  //       ports: device.item.ports?.map((p) => p),
  //       onoff: onoff,
  //       bright: device.item.bright,
  //       color: device.item.color,
  //     };
  //     mqttControl.onPublish(device.controllerId, device._id, {
  //       serial: device.controllerId,
  //       cmd: 'c',
  //       type: device.type,
  //       data: data,
  //     });
  //   await sleep(50);
  // }

  const virtualDevices = devices.filter((d) => d.isVirtual && onoff == 0 && d.item?.onoff == 1);
  for (const device of virtualDevices) {
    const params = { onoff: onoff, disableRollback: true };
    await requestVirtualDevicePower(params, device._id, groupId).catch((e) => {
      console.error('가상버튼 제어 실패:', device._id, e);
    });
    await sleep(50);
  }

  const realDevices = devices.filter((d) => !d.isVirtual);
  if (onoff == 0 && realDevices.length > 0) {
    try {
      const result = await Axios.get(VirtualDeviceApi.VIRTUAL_DEVICES_BY_MEMBERS, {
        deviceIds: realDevices.map((d) => d._id).join(','),
        mappingType: 1,
      });
      const mappedButtons = result?.resultData || [];
      const seenButtonIds = new Set();
      for (const btn of mappedButtons) {
        const btnId = String(btn._id);
        if (seenButtonIds.has(btnId) || btn.item?.onoff != 1) continue;
        seenButtonIds.add(btnId);
        // 보드가 맵으로 확장하므로 단일 Device MQTT OFF만 발행
        const ports = Array.isArray(btn.item?.ports) ? btn.item.ports : [btn.item?.ports];
        mqttControl.onPublish(btn.controllerId, btn._id, {
          serial: btn.controllerId,
          cmd: 'c',
          type: DeviceType.Lamp,
          data: {
            ports: ports.filter((p) => p != null),
            onoff: 0,
            bright: btn.item?.bright ?? 0,
            color: btn.item?.color ?? 0,
          },
        });
        store.commit('home/updateDevice', {
          groupId,
          id: btn._id,
          data: { item: { onoff: 0 } },
        });
        await sleep(50);
      }
    } catch (e) {
      console.error('physical mapping buttons 조회 실패:', e);
    }
  }

  const byController = {};
  for (const device of realDevices) {
    const cid = device.controllerId;
    if (!byController[cid]) {
      byController[cid] = { devices: [] };
    }
    byController[cid].devices.push(device);
  }

  for (const [controllerId, { devices: groupDevices }] of Object.entries(byController)) {
    const hasOnVirtual = groupDevices.some((d) => d?.onVirtual === true);
    const deviceIds = groupDevices.map((d) => d._id);
    const controller = findControllerInZone(zone.value?.controllers, controllerId);
    const useCs = supportsLampCmdCs(controller || controllerId);

    if (useCs) {
      // M24/M22/M02: cs로 포트별 밝기/색온도 유지하며 강제 적용
      const portsArr = [];
      const onoffArr = [];
      const brightArr = [];
      const colorArr = [];
      const seenPorts = new Set();
      for (const device of groupDevices) {
        const dports = Array.isArray(device.item?.ports)
          ? device.item.ports
          : (device.item?.ports != null ? [device.item.ports] : []);
        const bright = Number(device.item?.bright);
        const color = Number(device.item?.color);
        for (const p of dports) {
          const port = Number(p);
          if (!Number.isInteger(port) || seenPorts.has(port)) continue;
          seenPorts.add(port);
          portsArr.push(port);
          onoffArr.push(onoff ? 1 : 0);
          brightArr.push(Number.isFinite(bright) ? bright : 50);
          colorArr.push(Number.isFinite(color) ? color : 10);
        }
      }
      if (portsArr.length > 0) {
        mqttControl.onPublishBatch(controllerId, deviceIds, {
          serial: controllerId,
          cmd: 'cs',
          type: DeviceType.Lamp,
          data: {
            ports: portsArr,
            onoff: onoffArr,
            bright: brightArr,
            color: colorArr,
          },
        });
      }
    } else {
      // 구형 등 cs 미지원 → 개별과 동일하게 cmd `c`
      for (const device of groupDevices) {
        const dports = Array.isArray(device.item?.ports)
          ? device.item.ports
          : (device.item?.ports != null ? [device.item.ports] : []);
        const ports = dports.map((p) => Number(p)).filter((p) => Number.isInteger(p));
        if (ports.length === 0) continue;
        const bright = Number(device.item?.bright);
        const color = Number(device.item?.color);
        mqttControl.onPublish(controllerId, device._id, {
          serial: controllerId,
          cmd: 'c',
          type: DeviceType.Lamp,
          data: {
            ports,
            onoff: onoff ? 1 : 0,
            bright: Number.isFinite(bright) ? bright : 50,
            color: Number.isFinite(color) ? color : 10,
          },
        });
        await sleep(50);
      }
    }
    
    if (hasOnVirtual) {
      try {
        const result = await Axios.get(VirtualDeviceApi.VIRTUAL_DEVICES_BY_MEMBERS, {
          deviceIds: deviceIds.join(','),
        });
        const virtualDevices = result?.resultData || [];
        const virtualDeviceIds = new Set(virtualDevices.map((vd) => String(vd?._id)));
        const targetVirtualDevices = devices.filter(
          (d) =>
            d?.isVirtual === true &&
            d?.item?.onoff === 1 &&
            virtualDeviceIds.has(String(d?._id)),
        );
        targetVirtualDevices.forEach((vd) => {
          store.commit('home/updateDevice', {
            groupId: groupId,
            id: vd._id,
            data: { item: { onoff: 0 } },
          });
        });
      } catch (e) {
        console.error('virtualDevices(byMembers) 조회 실패:', e);
      }
    }

    await sleep(50);
  }

  setTimeout(() => emitter.emit('hideLoading'), devices.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
};

const onPublishCurtainPowerChanged = (devices, close, groupId) => {
  emitter.emit('showLoading');

  devices.forEach(async (device) => {
    if (device.isVirtual && onoff == 0 && device.item?.onoff == 1) {
      const params = { onoff: onoff, disableRollback: true };
      await requestVirtualDevicePower(params, device._id, groupId).catch((e) => {
        console.error('가상버튼 제어 실패:', device._id, e);
      });
    } else {
      if (close) {
        mqttControl.onPublishTemp(device.controllerId, MQTTCurtainCommand.IsClose, `${device.item.address}`);
      } else {
        mqttControl.onPublishTemp(device.controllerId, MQTTCurtainCommand.IsOpen, `${device.item.address}`);
      }
    }
  });

  setTimeout(() => emitter.emit('hideLoading'), devices.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
};

const onPublishDooyaPowerChanged = (devices, close, groupId) => {
  emitter.emit('showLoading');

  devices.forEach(async (device) => {
    if (device.isVirtual && onoff == 0 && device.item?.onoff == 1) {
      const params = { onoff: onoff, disableRollback: true };
      await requestVirtualDevicePower(params, device._id, groupId).catch((e) => {
        console.error('가상버튼 제어 실패:', device._id, e);
      });
    } else {
      mqttControl.onPublish(device.controllerId, device._id, {
        cmd: MQTTDooyaRonoCommand.DooyaCtrl,
        type: 1,
        data: getDooyaRonoCloseCtrlData(device.item, close),
      });
    }
  });

  setTimeout(() => emitter.emit('hideLoading'), devices.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
}

const onPublishRonoPowerChanged = (devices, close, groupId) => {
  emitter.emit('showLoading');

  devices.forEach(async (device) => {
    if (device.isVirtual && onoff == 0 && device.item?.onoff == 1) {
      const params = { onoff: onoff, disableRollback: true };
      await requestVirtualDevicePower(params, device._id, groupId).catch((e) => {
        console.error('가상버튼 제어 실패:', device._id, e);
      });
    } else {
      mqttControl.onPublish(device.controllerId, device._id, {
        cmd: MQTTDooyaRonoCommand.RonoCtrl,
        type: 1,
        data: getDooyaRonoCloseCtrlData(device.item, close),
      });
    }
  });

  setTimeout(() => emitter.emit('hideLoading'), devices.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
}

const onPublishBoilerPowerChanged = (devices, onoff, groupId) => {
  emitter.emit('showLoading');

  devices.forEach(async (device) => {
    if (device.isVirtual && onoff == 0 && device.item?.onoff == 1) {
      const params = { onoff: onoff, disableRollback: true };
      await requestVirtualDevicePower(params, device._id, groupId).catch((e) => {
        console.error('가상버튼 제어 실패:', device._id, e);
      });
    } else {
      mqttControl.onPublishTemp(device.controllerId, MQTTTempCommand.AwayModeSet, onoff);
    }
  });

  setTimeout(() => emitter.emit('hideLoading'), devices.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
};

const onEditZoneClick = () => {
  zoneModal.show();
};

const onUpdateZoneName = (value) => {
  requestUpdateZone({
    name: value,
  });
  zoneModal.hide();
};

const requestUpdateZone = async (params) => {
  try {
    const result = await Axios.patch(
      ZoneApi.UPDATE_ZONE.replace(':id', zone?.value._id),
      params,
    );
    if (result.resultCode === '0000') {
      store.commit('home/updateZone', {
        id: zone?.value._id,
        data: params,
      });
    } else {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '집 정보 수정에 실패했습니다.',
    });
  }
};

const requestVirtualDevicePower = async (params, id, groupId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const turnOn = params?.onoff == 1 || params?.onoff === true;
      // API/vc echo 전에 차일드 대표버튼이 켜져 보이지 않도록 즉시 고정
      if (turnOn) {
        const group = groups.value?.find((g) => g._id === groupId);
        (group?.devices || []).forEach((d) => {
          if (d?.isVirtual || d?.type !== 1) return;
          store.commit('home/updateDevice', {
            groupId: groupId,
            id: d._id,
            data: { onVirtual: true, item: { state: { onoff: 0 } } },
          });
        });
      }

      const result = await Axios.patch(SmarthomeApi.VIRTUAL_DEVICE_POWER.replace(":id", id), params);
      if (result.resultCode === '0000') {
        console.log(result, groupId)

        const prevId =
          result.resultData?.offItem?._id ??
          params?.onVirtualDeviceId ??
          null;

        if (result.resultData.onItem && result.resultData.offItem) {
          store.commit('home/updateDevice', {
            groupId: groupId,
            id: result.resultData.offItem._id,
            data: {
              item: { onoff: 0 }
            },
          });
          store.commit('home/updateDevice', {
            groupId: groupId,
            id: result.resultData.onItem._id,
            data: {
              item: result.resultData.onItem.item
            },
          });

          const onMemberDeviceIds = result.resultData.onItemMemberDeviceIds ?? [];
          const offMemberDeviceIds = result.resultData.offItemMemberDeviceIds ?? [];
          onMemberDeviceIds.forEach((memberId) => {
            store.commit('home/updateDevice', {
              groupId: groupId,
              id: memberId,
              data: { onVirtual: true, item: { state: { onoff: 0 } } },
            });
          });
          offMemberDeviceIds.forEach((memberId) => {
            store.commit('home/updateDevice', {
              groupId: groupId,
              id: memberId,
              data: { onVirtual: false, item: { onoff: 0 } },
            });
          });

        } else {
          store.commit('home/updateDevice', {
            groupId: groupId,
            id: id,
            data: {
              item: result.resultData.item
            },
          });

          const memberDeviceIds = result.resultData.memberDeviceIds ?? [];
          const onoff = result.resultData.item?.onoff ?? params?.onoff;
          const isOn = onoff == 1;
          memberDeviceIds.forEach((memberId) => {
            store.commit('home/updateDevice', {
              groupId: groupId,
              id: memberId,
              data: {
                onVirtual: isOn,
                ...(isOn
                  ? { item: { state: { onoff: 0 } } }
                  : { item: { onoff: 0 } }),
              },
            });
          });
        }

        await publishVirtualButtonLampsCmdC({
          mqttControl,
          store,
          virtualDeviceId: id,
          turnOn,
          prevVirtualDeviceId: turnOn ? prevId : null,
        }).catch((e) => {
          console.error('가상버튼 MQTT c 발행 실패:', id, e);
        });

        resolve(true);
        return;
      }

      reject(false);
      // emitter.emit('showPopAlert', {
      //   description: result.resultMessage,
      // });
    } catch (e) {
      reject(false);
      console.log(e);
      // emitter.emit('showPopAlert', {
      //   description: '가상버튼 ON/OFF에 실패했습니다.',
      // });
    }
  });
};

const onSettingClick = () => {
  router.push('/settings/zones');
};
</script>

<style scoped>
.rooms-page {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding: 1rem;
  margin: -1rem;
}

.page-empty-state {
  padding: 3rem 1rem;
  text-align: center;
}

.empty-state-icon {
  font-size: 3rem;
  color: #adb5bd;
  margin-bottom: 1rem;
}

.empty-state-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #212529;
  margin-bottom: 0.5rem;
}

.empty-state-description {
  font-size: 0.95rem;
  color: #6c757d;
  margin-bottom: 1.5rem;
}

.btn-primary {
  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
  border: none;
  padding: 0.75rem 1.25rem;
  font-weight: 500;
  border-radius: 0.5rem;
}
</style>
